import qs from 'qs';
import axiosInstances from '@/helper/axiosInstances';

const baseURL = import.meta.env.VITE_API_URL;

function project() {
	// Get a fresh axios instance for each request
	const getInstance = () => {
		const { axiosInstance } = axiosInstances();
		return axiosInstance;
	};

	function createProject(data, from = 'create') {
		const fData = new FormData();
		fData.append('qrstatus', data.qrstatus);
		fData.append('productprefixid', data.productprefixid);
		fData.append('productcodenumber', data.productcodenumber);
		fData.append('productname', data.productname);
		fData.append('category', data.category || 0);
		fData.append('article', data.article ? JSON.stringify(data.article) : '[]');
		fData.append('description', data.description);
		fData.append('productcomponentflag', data.productcomponentflag);
		fData.append('producttype', data.producttype);
		if (from === 'create') {
			fData.append('productversion', data.productversion || '-');
		} else if (from === 'edit') {
			if (data.productversion && data.productversion !== '-') fData.append('productversion', data.productversion);
		}
		fData.append('referenceid', '0');
		fData.append('status', data.status || '');
		fData.append('producturl', data.producturl || '');

		fData.append('referencerelation', JSON.stringify(data.referencerelation?.length ? data.referencerelation : []));

		fData.append('projectrelations', data.projectrelations?.length ? JSON.stringify(data.projectrelations) : '[]');

		fData.append('attachments', data.attachments?.length ? JSON.stringify(data.attachments) : '[]');

		if (data.files_uploaded?.length) {
			data.files_uploaded.forEach((file, index) => {
				fData.append(`files_uploaded[${index}]`, file);
			});
		}

		return fData;
	}

	async function getProductPrefix(params) {
		const method = 'get';
		let url = `${baseURL}productprefix/`;
		const response = await getInstance().request({
			method,
			url,
			params,
		});
		return response;
	}

	async function getProductGroup(params, id = null) {
		const method = 'get';
		let url = `${baseURL}groupcategory/`;
		if (id) url += `${id}/`;
		const response = await getInstance().request({
			method,
			url,
			params,
		});
		return response;
	}

	async function getProductCategory(params, id = null) {
		const method = 'get';
		let url = `${baseURL}categorycomponent/`;
		if (id) url += `${id}/`;
		const response = await getInstance().request({
			method,
			url,
			params,
		});
		return response;
	}

	async function getProductReference(params) {
		const method = 'get';
		let url = `${baseURL}referencetype/`;
		const response = await getInstance().request({
			method,
			url,
			params,
		});
		return response;
	}

	async function getProducts(params) {
		const method = 'get';
		let url = `${baseURL}component/`;
		const response = await getInstance().request({
			method,
			url,
			params,
			paramsSerializer: (params) => {
				return qs.stringify(params, { arrayFormat: 'repeat', encode: false });
			},
		});
		return response;
	}

	async function getGlobalProducts(params) {
		const method = 'get';
		let url = `${baseURL}component/`;
		const response = await getInstance().request({
			method,
			url,
			params,
			paramsSerializer: (params) => {
				return qs.stringify(params, { arrayFormat: 'repeat', encode: false });
			},
		});
		return response;
	}

	async function getProduct(id, params = {}) {
		const method = 'get';
		let url = `${baseURL}component/${id}/`;
		const response = await getInstance().request({
			method,
			url,
			params,
		});
		return response;
	}

	async function getGlobalProduct(id, params) {
		const method = 'get';
		let url = `${baseURL}component/${id}/`;
		const response = await getInstance().request({
			method,
			url,
			params,
			headers: {
				'Content-Type': 'application/json',
			},
		});
		return response;
	}

	async function getProductRefType(params) {
		const method = 'get';
		let url = `${baseURL}referencetype/`;
		const response = await getInstance().request({
			method,
			url,
			params,
		});
		return response;
	}

	async function getProductStatus(params) {
		const method = 'get';
		let url = `${baseURL}projectstatus/`;
		const response = await getInstance().request({
			method,
			url,
			params,
		});
		return response;
	}

	async function getMaxCodeNumber(params) {
		const method = 'get';
		let url = `${baseURL}last_component/`;
		const response = await getInstance().request({
			method,
			url,
			params,
		});
		return response;
	}

	async function deleteCategory(id) {
		const method = 'delete';
		const url = `${baseURL}categorycomponent/${id}/`;
		const response = await getInstance().request({
			method,
			url,
		});
		return response;
	}

	async function updateGroupCategory(id, data) {
		const method = 'patch';
		const url = `${baseURL}groupcategory/${id}/`;
		const response = await getInstance().request({
			data,
			method,
			url,
		});
		return response;
	}

	return {
		createProject,
		getProductPrefix,
		getProductGroup,
		getProductCategory,
		getProductReference,
		getProducts,
		getGlobalProducts,
		getProduct,
		getGlobalProduct,
		getProductRefType,
		getProductStatus,
		getMaxCodeNumber,
		deleteCategory,
		updateGroupCategory
	};
}

export default project;
